// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"b4aa8a6f","2408":"a0436a7a","9581":"a0436a7a"}[chunkId] + ".chunk.css";
};